import React from 'react'
import { connect } from 'react-redux'
import { doGetEmailTemplet, doSaveEmailTemplet, doDeleteEmailTemplet } from '../../reducers/actions'

class EmailTempletDiv extends React.Component {
  state = {}
  componentDidMount = () => {
    const { onClose, dispatch, id } = this.props
    dispatch(doGetEmailTemplet({
      id,
      onEnd: ({ errorMessage, initValues基本信息 }) => {
        if (errorMessage) {
          Tyan.pubForm.showError(errorMessage)
        }
        else if (initValues基本信息) {
          this.setState({ id, initValues基本信息, changedValues基本信息: {} })
        }
      }
    }))
  }

  handlerConfirm = () => {
    const { initValues基本信息, changedValues基本信息, id } = this.state
    const { onSave, onClose, dispatch } = this.props
    dispatch(doSaveEmailTemplet({
      id,
      changedValues基本信息,
      onEnd: ({ errorMessage }) => {
        if (errorMessage) {
          Tyan.pubForm.showError(errorMessage)
        }
        else {
          Ext.toast('保存成功')
          onSave && onSave()
          onClose && onClose()
        }
      }
    }))
  }

  handlerDelete = () => {
    const { id } = this.state
    const { onSave, onClose, dispatch } = this.props

    Tyan.pubForm.showConfirm('确定要删除？', () =>
      dispatch(doDeleteEmailTemplet({
        id,
        onEnd: ({ errorMessage }) => {
          if (errorMessage) {
            Tyan.pubForm.showError(errorMessage)
          }
          else {
            Ext.toast('删除成功')
            onSave && onSave()
            onClose && onClose()
          }
        }
      })))
  }


  handlerClose = () => {
    const { onClose } = this.props
    onClose && onClose()
  }

  canSave = () => {
    const { initValues基本信息, changedValues基本信息, id } = this.state
    return Object.keys(changedValues基本信息).length > 0 || id < 0
  }

  fieldset基本信息 = () => {
    const { initValues基本信息, changedValues基本信息 } = this.state
    const values = { ...initValues基本信息, ...changedValues基本信息 }
    return [
      { _text: '名称', name: '邮件模板名称', minWidth: '1000px', },
      { _text: '参数', name: '邮件模板参数', minWidth: '1000px', },
      { _text: '相关对象列表', name: '相关对象列表', minWidth: '1000px', },
      { _text: '发送者服务器', name: '邮件服务器地址', minWidth: '1000px', },
      { _text: '发送者邮箱', name: '发送者邮箱', minWidth: '1000px', },
      { _text: '接收者邮箱', name: '收邮件邮箱', minWidth: '1000px', },
      { _text: '抄送', name: '抄送', minWidth: '1000px', },
      { _text: '密抄', name: '密抄', minWidth: '1000px', },
      { _text: '联系人来源', name: '联系人来源', minWidth: '1000px', },
      { _text: '默认邮箱域名', name: '邮件域名', minWidth: '1000px', },
      { _text: '账号', name: '邮件发送者账号', minWidth: '1000px', },
      { _text: '密码', name: '邮件发送者密码', minWidth: '1000px', },
      { _text: '邮件主题', name: '邮件主题', minWidth: '1000px', },
      { _text: '发送条件', name: '发送条件', minWidth: '1000px', },

      { _number: '最大发送次数', name: '最大发送次数', minWidth: '1000px', },
      { _text: '发送起始时间', name: '发送起始时间', minWidth: '1000px', },
      { _text: '发送截止时间', name: '发送截止时间', minWidth: '1000px', },
      { _radio: '模板类型', name: '模板类型', itemMinWidth: 100, items: ['XML模板', 'Razor模板'], margin: "0px 20px 0px 20px", minWidth: '90%' },
      //{ _checkbox: '支持TLS加密', name: '支持TLS加密', itemMinWidth: 200, items: ['是', '否'], margin: "0px 20px 0px 20px", minWidth: '600px' },
      { _radio: '支持TLS加密', name: '支持TLS加密', itemMinWidth: 100, items: ['是', '否'], margin: "0px 20px 0px 20px", minWidth: '90%' },
      { _text: '代码', name: '邮件模板代码', minWidth: '1000px', maxRows: 8 },
      { _text: '内容', name: '邮件内容模板', minWidth: '1000px', maxRows: 8, cdt: () => values.模板类型 == "XML模板", },

    ]
  }

  render() {
    const { showMessage: Message, showBody: Body, id } = this.props
    const { initValues基本信息, changedValues基本信息 } = this.state
    if (!initValues基本信息) return <Message text={'请稍等 ...'} />
    const canSave = this.canSave()
    return <Body data={this} maxWidth="1000"
      controls={
        [
          { _button: '保存', icon: 'save', handler: this.handlerConfirm, disabled: !canSave },
          { _button: '删除', icon: 'trash-o', ui: 'action decline alt', cdt: () => id > 0, handler: this.handlerDelete },
          { _button: '关闭', icon: 'close', handler: this.handlerClose },
        ]}
      fieldsets={
        [
          { title: '', name: '基本信息', _fieldset: this.fieldset基本信息() },
        ]}
    />
  }
}

export default connect()(EmailTempletDiv)